import { effect, Injectable, signal } from '@angular/core';
import { GlobalConfig } from '@c3library/models/global-settings';
import { MessageService } from 'primeng/api';
import { environment } from '@environments/environment';

const DEFAULT_GLOBAL_CONFIG: GlobalConfig = environment.globalConfig;

@Injectable({
  providedIn: 'root',
})


export class GlobalSettingsService {


  private readonly _globalConfig = signal<GlobalConfig>(DEFAULT_GLOBAL_CONFIG);
  readonly globalConfig = this._globalConfig.asReadonly();

  constructor() {
    this.applyTheme(this._globalConfig());

    effect(() => {
      this.applyTheme(this._globalConfig());
    });
  }


  isGlobalSettingEnabled<g extends keyof GlobalConfig['globalSettings']>(setting: g): boolean {
    return this._globalConfig().globalSettings[setting] as boolean;
  }

  get globalTheme() {
    return this._globalConfig().globalTheme;
  }

  get globalSettings() {
    return this.globalConfig().globalSettings;
  }


  private applyTheme(config: GlobalConfig) {
    const root = document.documentElement;
    root.style.setProperty('--app-primary-color', config.globalTheme.primarySiteColor);
    root.style.setProperty('--app-secondary-color', config.globalTheme.secondarySiteColor);
    root.style.setProperty('--app-tertiary-color', config.globalTheme.tertiarySiteColor);

    root.style.setProperty('--app-critical', config.globalTheme.critical);
    root.style.setProperty('--app-high', config.globalTheme.high);
    root.style.setProperty('--app-medium', config.globalTheme.medium);
    root.style.setProperty('--app-low', config.globalTheme.low);
    root.style.setProperty('--app-very-low', config.globalTheme.veryLow);
  }


  showErrorIfFieldBlank_String(f: any, fieldName: string, ms: MessageService): boolean {

    if (f == null || f == undefined || f == '') {
      ms.add({ severity: 'error', summary: 'Error saving', detail: `You must specify the ${fieldName} field`, sticky: false });
      return true;
    }
    return false;
  }
  showErrorIfFieldBlank_Number(f: any, fieldName: string, ms: MessageService): boolean {

    if (f == null || f == undefined || f == '' || isNaN(f)) {
      ms.add({ severity: 'error', summary: 'Error saving', detail: `You must specify the ${fieldName} field`, sticky: false });
      return true;
    }
    return false;
  }

}
